<div class="row cookie-consent-row">
  <div class="col-md-12">
    <div class="cookie-consent">
      <span class="cookie-consent-text">
        {{ consentsTranslations | getConsentsTranslation:COOKIES_CONSENT_KEY:'read_more' }}
      </span>

      <div class="cookie-consent-privacy-cookie-links">
        <a [href]="legalDocumentLinks.privacyPolicyHref" target="_blank">
          {{ 'generic.privacy_link' | translate }}
        </a>

        @if (legalDocumentLinks.hasCookiePolicy$ | async) {
          <a [href]="legalDocumentLinks.cookiePolicyHref" target="_blank">
            {{ 'generic.cookies_link' | translate }}
          </a>
        }
      </div>

      <div class="cookie-consent-buttons">
        <button (click)="acceptCookies()"
                class="btn btn-primary btn-raised cookie-consent-yes"
                type="button">
          {{ consentsTranslations | getConsentsTranslation:COOKIES_CONSENT_KEY:'__yes__' }}
        </button>
        <button (click)="rejectCookies()"
                class="btn btn-default cookie-consent-no"
                type="button">
          {{consentsTranslations | getConsentsTranslation:COOKIES_CONSENT_KEY:'__no__'}}
        </button>
      </div>
    </div>
  </div>
</div>
